import React, { useEffect, useContext } from 'react';
import ReactDom from 'react-dom';

import { Context } from '@store/store';

import { StyledEditorsModal } from './editor-modal.styles';

const EditorModal = () => {
  const [state, dispatch] = useContext(Context);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch({ type: 'SHOW_EDITOR_MODAL', payload: false });
    }, 2000);
    return () => clearTimeout(timer);
  }, [state.isEditorModalShown]);

  return state.isEditorModalShown ?
      ReactDom.createPortal(
          <StyledEditorsModal>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.36 19.78L12 13.41L5.63997 19.78L4.21997 18.36L10.59 12L4.21997 5.63997L5.63997 4.21997L12 10.59L18.36 4.22997L19.77 5.63997L13.41 12L19.77 18.36L18.36 19.78Z"
                fill="#979797"
              />
            </svg>
            {state.isEditorModalShownText ? state.isEditorModalShownText : 'Документ удален'}
          </StyledEditorsModal>,
          document.getElementById('modal'),
        )
    : ReactDom.createPortal(null, document.getElementById('modal'));
};

export default EditorModal;
